import { createRatesCityRequest } from "../../data/ratesCityApi";
import { validateTarifaCityPayload } from "../validator/validateTarifaCityPayload";

export async function createTarifaCityUseCase(payload) {
  const error = validateTarifaCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createRatesCityRequest(payload);
}
